import React, { useEffect, useState } from "react";
import tw, { styled, css } from "twin.macro";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";
import { useModal } from "./ModalContext";

import PlayButton from "./PlayButton";

const Div = styled.button(({ fc2, isVisible, top, bottom }) => [
  tw`relative flex items-center duration-[1.5s] overflow-hidden justify-center ease-in-out blur-sm opacity-0 shadow-lg [.thumbnail]:(duration-700 ease-in-out) 
	hover:(shadow-2xl [.thumbnail]:(scale-105 brightness-105) [.icon]:animate-pulse)`,

  top && tw` self-start mb-24 translate-x-[-100px]`,
  bottom && tw`self-end  translate-x-[100px]`,
  fc2 && tw`scale-90 translate-y-[-6rem]`,

  isVisible && tw`blur-0 scale-100 translate-x-0 opacity-100`,
  isVisible && fc2 && tw`translate-y-[-10rem]`,

  (top || bottom) && tw`lg:max-w-none sm:max-w-[30rem]`,
]);

const ThumbnailVideo = ({ embed, thumbnail, ...rest }) => {
  const { openModal } = useModal();

  const [isVisible, setIsVisible] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  return (
    <Div
      {...rest}
      ref={ref}
      isVisible={isVisible}
      onClick={() => openModal(embed)}
    >
      {!!thumbnail && (
        <GatsbyImage
          className="thumbnail"
          image={getImage(thumbnail.localFile)}
          alt={thumbnail.altText}
        />
      )}
      <PlayButton />
    </Div>
  );
};

export default ThumbnailVideo;
